// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1UNw7","label":"CategoryService_label__QWuaw","location":"CategoryService_location__-urXI"};